import { createContext, useContext } from 'react';

export const RefinedUIContext = createContext(false);

// Existing screens inherit the user's appearance flag. Explicit overrides
// still control the original pilot and its local comparison.
export function useRefinedUI(explicitValue) {
  const enabled = useContext(RefinedUIContext);
  return explicitValue ?? enabled;
}
